// extracted by mini-css-extract-plugin
module.exports = {"baseDropdownMenu":"BaseDropdownMenu_baseDropdownMenu_8_aq2"};